import MonixModal from "@/global/components/monix-modal";
import { Spin } from "antd";
import { useEffect, useState } from "react";
import { ReactComponent as CheckSvg } from '@/global/icons/table/check.svg';
import { ReactComponent as CheckedSvg } from '@/global/icons/table/checked.svg';
import { useParams } from "react-router-dom";
import TnMessage from "@/global/components/message";
import { GlobalSensor } from "@/global/interface/lib-device/global-sensor";
import { getGlobalSensors } from "@/api/lib/lib-sensor";
import { User } from "@/global/interface/project-manage/user";
import { getUsers } from "@/api/lib/user";
import { findProjectUserDetail } from "@/api/project-manage/project-user";
import './index.less';
import { GENDER_TYPE } from "@/enums/user";

interface IProps {
    userId: number
    visible: boolean
    setVisible: (value: boolean) => void
}

export default function ProjectUserDetailModal(props: IProps) {
    const { projectId } = useParams();
    const [user, setUser] = useState<User>(null); // 用户信息
    const [loading, setLoading] = useState<boolean>(false); // 加载loading

    useEffect(() => {
        if (!props.visible) {
            setLoading(false);
        }
    }, [props.visible])

    // 初始化
    useEffect(() => {
        generateData();
    }, [])

    // 获取可选择数据
    const generateData = () => {
        if (!props?.userId) return;
        setLoading(true);
        findProjectUserDetail(+projectId, props.userId).then(res => {
            if (res.status === 200) {
                let data: User = res.data || null;
                setUser(data);
            }
        }).catch(err => {
            TnMessage.error("获取用户失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <MonixModal
            title={"详细信息"}
            visible={props.visible}
            setVisible={(e) => props.setVisible(e)}
            wrapClassName="user-detail-modal"
            hideFooter={true}
        >
            <Spin wrapperClassName="user-detail-body" spinning={loading}>
                <div className="detail-body">
                    <div className="info-row">
                        <div className="info-left">姓名:</div>
                        <div className="info-right">{user?.name || ''}</div>
                    </div>
                    <div className="info-row">
                        <div className="info-left">性别:</div>
                        <div className="info-right">{user?.gender === GENDER_TYPE.MALE ? '男' : '女'}</div>
                    </div>
                    <div className="info-row">
                        <div className="info-left">职位:</div>
                        <div className="info-right">{user?.positionName || ''}</div>
                    </div>
                    <div className="info-row">
                        <div className="info-left">单位:</div>
                        <div className="info-right">{user?.enterprise || ''}</div>
                    </div>
                    <div className="info-row">
                        <div className="info-left">地址:</div>
                        <div className="info-right">{user?.address || ''}</div>
                    </div>
                    <div className="info-row">
                        <div className="info-left">部门:</div>
                        <div className="info-right">{user?.department || ''}</div>
                    </div>
                    <div className="info-row">
                        <div className="info-left">电话:</div>
                        <div className="info-right">{`${user?.mobile || ''}`}</div>
                    </div>
                    <div className="info-row">
                        <div className="info-left">邮箱:</div>
                        <div className="info-right">{user?.email || ''}</div>
                    </div>
                </div>
            </Spin>
        </MonixModal>
    )
}